import { Badge, Box, Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, SimpleGrid, Text, useDisclosure, VStack } from '@chakra-ui/react';
import { QRCodeSVG } from 'qrcode.react';
import { useState } from 'react';

export const UserRewardsList = ({ rewards }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedReward, setSelectedReward] = useState(null);

    if (!rewards || rewards.length === 0) {
        return null;
    }

    const handleOpenCode = (reward) => {
        setSelectedReward(reward);
        onOpen();
    };

    return (
        <Box w='full' mt={2}>
            <Text fontSize='lg' fontWeight='bold' color='gray.800' mb={4}>
                My Rewards
            </Text>
            <SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 4 }} spacing={4}>
                {rewards.map((voucher) => {
                    const expiryDate = new Date(voucher.expiryDate.replace(' ', 'T'));
                    const now = new Date();
                    const diffTime = expiryDate.getTime() - now.getTime();
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                    let badgeText = 'Ready to Use';
                    if (diffDays < 0) {
                        badgeText = 'Expired';
                    } else if (diffDays < 5) {
                        badgeText = `${diffDays} days left`;
                    }

                    return (
                        <Flex key={voucher.id} direction='column' bg='white' p={5} borderRadius='xl' border='1px' borderColor='red.200' boxShadow='sm' transition='all 0.2s' _hover={{ transform: 'translateY(-4px)', boxShadow: 'md', borderColor: 'red.300' }}>
                            <Flex justify='space-between' align='start' mb={3}>
                                <Box fontSize='3xl' bg='red.50' p={2} borderRadius='lg'>
                                    {voucher.image || '🎟️'}
                                </Box>
                                <Badge colorScheme='red' borderRadius='full' px={3} py={1} fontSize='xs' fontWeight='bold'>
                                    {badgeText}
                                </Badge>
                            </Flex>

                            <Text fontWeight='bold' color='gray.800' mb={2} fontSize='md' noOfLines={1}>
                                {voucher.title}
                            </Text>

                            <Text fontSize='sm' color='gray.500' mb={2} flex={1} noOfLines={2} textOverflow='ellipsis'>
                                {(voucher.description || '').toString().trim()}
                            </Text>

                            <Box mb={4}>
                                <Badge colorScheme='purple' variant='subtle' rounded='md' textTransform='capitalize'>
                                    Exp Date: {expiryDate.toLocaleDateString()}
                                </Badge>
                            </Box>

                            <Box mt='auto' pt={3} borderTop='1px dashed' borderColor='gray.100'>
                                <Button w='full' size='sm' colorScheme='red' borderRadius='full' onClick={() => handleOpenCode(voucher)}>
                                    Redeem
                                </Button>
                            </Box>
                        </Flex>
                    );
                })}
            </SimpleGrid>

            {/* Redeem Modal */}
            <Modal isOpen={isOpen} onClose={onClose} isCentered size='sm'>
                <ModalOverlay backdropFilter='blur(4px)' />
                <ModalContent borderRadius='2xl' overflow='hidden'>
                    <ModalHeader bg='red.500' color='white' textAlign='center'>
                        Redeem Voucher
                    </ModalHeader>
                    <ModalCloseButton color='white' />
                    <ModalBody p={6}>
                        {selectedReward && (
                            <VStack spacing={6}>
                                <Text fontWeight='bold' fontSize='lg' textAlign='center'>
                                    {selectedReward.title}
                                </Text>
                                <Box p={4} bg='white' borderRadius='xl' boxShadow='sm' border='1px solid' borderColor='gray.100'>
                                    <QRCodeSVG value={selectedReward.redeemCode || 'NO-CODE'} size={180} />
                                </Box>
                                <VStack spacing={1}>
                                    <Text fontSize='sm' color='gray.500'>
                                        Redeem Code
                                    </Text>
                                    <Text fontSize='2xl' fontWeight='black' letterSpacing='widest' color='red.600'>
                                        {selectedReward.redeemCode}
                                    </Text>
                                </VStack>
                                <Text fontSize='xs' color='gray.400' textAlign='center'>
                                    Show this QR code to the ticketing crew at any of our parks and enjoy your reward.{' '}
                                </Text>
                            </VStack>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Box>
    );
};
